// EventDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEventContext } from '../contexts/EventContext';
import { EventDetailProvider, useEventDetailContext } from '../contexts/EventDetailContext';
import { DiaporamaSettingsProvider } from '../contexts/DiaporamaSettingsContext';
import { QRCodeSVG } from 'qrcode.react';
import DiaporamaBox from '../components/DiaporamaBox';
import { BackgroundProvider } from '../contexts/BackgroundContext';
import SettingsMenu from '../components/EventSettings';
import './style/EventDetails.css';
import { FaHome, FaFileAlt, FaCog, FaUpload, FaChevronLeft, FaChevronRight, FaPlay, FaCopy, FaCheck } from 'react-icons/fa';
import { DiaporamaGlobalProvider, useDiaporamaGlobal } from '../contexts/DiaporamaGlobalContext';
import ContenuElements from '../components/ContenuElements';
import UploadMultipleImg from '../components/UploadMultipleImg';
import { Breadcrumbs } from '@aws-amplify/ui-react';
import { MdChevronRight } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { SUBSCRIPTION_LIMITS } from '../constants/subscriptionRules';
import LoadingLogo from '../components/LoadingLogo';
import { useTranslation } from 'react-i18next';
import CagnotteBox from '../components/CagnotteBox';
import DisplayOptions from '../components/DisplayOptions';
import DisplayShare from '../components/DisplayShare';
import { useNavigate } from 'react-router-dom';



function EventDetailContent({ event, activeTab }) {
  const { details, loadingDetails, errorDetails, fetchEventDetails } = useEventDetailContext();
  const { isRunning } = useDiaporamaGlobal();
  const [contentTab, setContentTab] = useState('images');
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
 
  
  

  // Chargement initial
  useEffect(() => {
    if (event?.eventId) {
      fetchEventDetails(event.eventId);
    }
  }, [event?.eventId]);

  // Auto-refresh si le diaporama est actif
  useEffect(() => {
    let intervalId;
    if (isRunning && event?.eventId) {
      fetchEventDetails(event.eventId); // appel immédiat
      intervalId = setInterval(() => {
        fetchEventDetails(event.eventId);
      }, 60000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isRunning, event?.eventId]);

  const filteredDetails = details;
  const totalPictures = filteredDetails.filter(item => item.signedUrl).length;
  const totalTexts = filteredDetails.filter(item => item.commentaire && !item.signedUrl).length;

  const sub = event.Sub || "P0"; // fallback P0 si jamais Sub est vide
  const limits = SUBSCRIPTION_LIMITS[sub] || SUBSCRIPTION_LIMITS["P0"];

  const nbPictures = Number(event.NumberPicture) || 0;
  const nbComments = Number(event.NumberComment) || 0;

  // gestion du cas illimité (ex: maxComments: 5000 = P4, ou tu veux écrire "Illimité")
  const maxPics = limits.maxPictures;
  const maxComs = limits.maxComments;

  const illimitePics = maxPics === 0 || maxPics >= 5000; // à adapter selon ta logique
  const illimiteComs = maxComs === 0 || maxComs >= 5000;
  const isUnlimitedPics = sub === "P4";
  const isUnlimitedComs = sub === "P4";

  const [copied, setCopied] = useState(false);
  const handleCopyUrl = async () => {
  const url = `${window.location.origin}/${event.eventId}/upload`;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // Fallback pour vieux navigateurs
      const ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } finally {
        document.body.removeChild(ta);
      }
    }
  };


  return (
    <div className="event-content-wrapper">
      <div className="event-tab-content">
        {activeTab === 'home' && (
          <div className="event-info">
            <h3>{t('eventDetail.home.title')}</h3>
            <p><strong>{t('eventDetail.home.name')} :</strong> {event.eventName}</p>
            <p><strong>{t('eventDetail.home.eventId')} :</strong> {event.eventId}</p>
            <p><strong>{t('eventDetail.home.creationDate')} :</strong> {
              (() => {
                const datePart = event.createdAt?.split(' ')[0]; // ex: "03/07/2025"
                const [day, month, year] = datePart?.split('/') || [];
                if (day && month && year) {
                  return `${day}/${month}/${year}`;
                }
                return 'Date invalide';
              })()
            }</p>

            <div style={{ marginTop: '30px', textAlign: 'center' }}>
              <h4>{t('eventDetail.home.qrCodeTitle')}</h4>
              <DisplayShare 
                eventId={event.eventId} 
                eventName={event.eventName}
                qrCodeUrl={`${window.location.origin}/${event.eventId}/upload`}
              />
              <DisplayOptions />
              <div className="event-link" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '12px', marginTop: '8px' }}>
                <span>URL :</span>
                <a
                  href={`${window.location.origin}/${event.eventId}/upload`}
                  target="_blank"
                  rel="noreferrer"
                  style={{ wordBreak: 'break-all' }}
                >
                  {`${window.location.origin}/${event.eventId}/upload`}
                </a>

                <button
                  type="button"
                  onClick={handleCopyUrl}
                  className="copy-url-btn"
                  title="Copier le lien"
                >
                  {copied ? <FaCheck /> : <FaCopy />}
                </button>

               
              </div>


              <div style={{ marginTop: '20px' }}>
                📷 <strong>{totalPictures}</strong> {t('eventDetail.home.images')} — 📝 <strong>{totalTexts}</strong> {t('eventDetail.home.comments')}
              </div>
              {(() => {
                const sub = event.Sub || "P0";
                const limits = SUBSCRIPTION_LIMITS[sub] || SUBSCRIPTION_LIMITS["P0"];
                const nbPictures = Number(event.NumberPicture) || 0;
                const nbComments = Number(event.NumberComment) || 0;
                const isUnlimitedPics = sub === "P4";
                const isUnlimitedComs = sub === "P4";
                const maxPics = limits.maxPictures;
                const maxComs = limits.maxComments;
                return (
                  <div style={{ marginTop: 15, fontSize: 13, color: "#ffd700", fontWeight: 500 }}>
                    <div
                      style={{
                        marginTop: 8,
                        fontSize: 13,
                        color: "#ffd700",
                        fontWeight: 500,
                        display: 'flex',
                        gap: 20, // espace entre les deux blocs, ajuste selon besoin
                        alignItems: 'center',
                        justifyContent: 'center', // <<< Ajoute ceci pour centrer
                      }}
                    >
                      <span>
                        {t('eventDetail.home.remainingComments')} :
                        {isUnlimitedComs
                          ? <span style={{ color: "#4caf50" }}> {t('eventDetail.home.unlimited')}</span>
                          : <span> {maxComs - nbComments} / {maxComs}</span>
                        }
                      </span>
                      <span>
                        {t('eventDetail.home.remainingImages')} :
                        {isUnlimitedPics
                          ? <span style={{ color: "#4caf50" }}> {t('eventDetail.home.unlimited')}</span>
                          : <span> {maxPics - nbPictures} / {maxPics}</span>
                        }
                      </span>
                    </div>

                  </div>
                );
              })()}


              <UploadMultipleImg
                eventId={event.eventId}
                expanded={expanded}
                setExpanded={setExpanded}
              />

              
              <CagnotteBox event={event} />


            </div>
          </div>
        )}

        {activeTab === 'diaporama' && (
          <BackgroundProvider>
            <DiaporamaBox
              eventId={event.eventId}
              qrCodeUrl={`${window.location.origin}/${event.eventId}/upload`}
              eventName={event.eventName}
            />
          </BackgroundProvider>
        )}

        {activeTab === 'contenu' && (
          <div style={{ padding: '10px' }}>
            <ContenuElements
              items={filteredDetails.filter(item => {
                if (contentTab === 'images') return item.signedUrl;
                if (contentTab === 'commentaires') return item.commentaire && !item.signedUrl;
                return true;
              })}
              type={contentTab}
              tabSelector={contentTab}
              setTabSelector={setContentTab}
            />
          </div>
        )}

        

      </div>
    </div>
  );
}

function EventDetail() {
  const { eventId } = useParams();
  const { events, loadingEvents, errorEvents } = useEventContext();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [activeTab, setActiveTab] = useState('home');
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
   


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    handleResize(); // appel initial
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  

  if (loadingEvents) return <LoadingLogo />;
  if (errorEvents) return <div style={{ color: 'red' }}>{t('eventDetail.errors.loadingError')} : {errorEvents}</div>;

  const event = events.find(e => e.eventId === eventId);
  if (!event) return <div style={{ textAlign: 'center' }}>{t('eventDetail.errors.eventNotFound')}</div>;

  return (
    <EventDetailProvider>
      <BackgroundProvider>
        <DiaporamaSettingsProvider>
          <DiaporamaGlobalProvider>
            <div className="event-detail-container">
              <div className="sidebar-toggle-button" onClick={() => setSidebarVisible(prev => !prev)}>
                {sidebarVisible ? <FaChevronLeft /> : <FaChevronRight />}
              </div>
              <div className={`sidebar ${sidebarVisible ? 'visible' : 'hidden'}`}>
                <div className="sidebar-section">
                  <a href="#" onClick={() => setActiveTab('home')} data-tooltip="Accueil de l'événement"><FaHome /> {t('eventDetail.sidebar.home')}</a>
                  <a href="#" onClick={() => setActiveTab('diaporama')} data-tooltip="Voir le diaporama"><FaPlay /> {t('eventDetail.sidebar.diaporama')}</a>
                  <a href="#" onClick={() => setActiveTab('contenu')} data-tooltip="Contenu lié"><FaFileAlt /> {t('eventDetail.sidebar.content')}</a>
                  <a
                    href="#"
                    onClick={() => navigate('/generalsettings')}
                    className="sidebar-settings-link"
                  >
                    <FaCog /> Paramètres Général
                  </a>
                </div>
                <div className="sidebar-scrollable">
                  <SettingsMenu />
                </div>
              </div>
              <div className="content">
                <div>
                  <Breadcrumbs
                    items={[
                      { label: '' }, // non cliquable
                      { href: '/events', label: t('eventDetail.breadcrumbs.events') },
                      { label: event.eventName || t('eventDetail.breadcrumbs.event') },
                      { label:
                          activeTab === 'home'
                            ? t('eventDetail.sidebar.home')
                            : activeTab === 'diaporama'
                            ? t('eventDetail.sidebar.diaporama')
                            : activeTab === 'contenu'
                            ? t('eventDetail.sidebar.content')
                            : ''
                      }
                    ]}
                    separator={<MdChevronRight style={{ color: '#facc15' }} />}
                  />
                </div>
                <EventDetailContent event={event} activeTab={activeTab} />
              </div>
            </div>
          </DiaporamaGlobalProvider>
        </DiaporamaSettingsProvider>
      </BackgroundProvider>
    </EventDetailProvider>
  );
}

export default EventDetail;
